import { IncomeSplitWidget as SharedIncomeSplitWidget } from '@fruitful/agent-ui';
import { type IncomeSplitWidgetProps } from '@fruitful/types';
import React from 'react';

import { useGetIncomeSplitOverviewFromGlobalState } from '../../../banking/components/income-split/hooks/useGetIncomeSplitOverviewFromGlobalState';
import { trackDepositDetailsClicked } from '../../../banking/components/income-split/overview/trackDepositDetailsClicked';

export const IncomeSplitWidget = (props: IncomeSplitWidgetProps) => {
    const { data, isLoading, isError } =
        useGetIncomeSplitOverviewFromGlobalState();

    return (
        <SharedIncomeSplitWidget
            {...props}
            data={data}
            isLoading={isLoading}
            isError={isError}
            onPressExecution={trackDepositDetailsClicked}
        />
    );
};
